import { render, staticRenderFns } from "./ChoiceDifficulty.vue?vue&type=template&id=39a4da78&scoped=true&"
import script from "./ChoiceDifficulty.vue?vue&type=script&lang=js&"
export * from "./ChoiceDifficulty.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceDifficulty.vue?vue&type=style&index=0&id=39a4da78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a4da78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
